/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { EcoLabelItemFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { EcoLabelItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import deepmerge from 'deepmerge';

export const ecoLabelItemDataMock: EcoLabelItemFragmentFragment = {
  iconUrl: 'https://bilder.baur.de/i/empiriecom/eco_madeingreenbyoekotex',
  license: 'EGL/151775',
  serviceLayerId: 'eco_madeingreenbyoekotex',
  text: 'MADE IN GREEN by OEKO-TEX®',
};

export function getEcoLabelItemFragmentedData(data?: EcoLabelItemFragmentFragment) {
  return makeFragmentData(data || ecoLabelItemDataMock, EcoLabelItemFragmentFragmentDoc);
}

export const ecoLabelItemDataMockEmptyDialog = deepmerge(ecoLabelItemDataMock, {
  iconUrl: null,
  text: null,
});

export const ecoLabelItemDataMockLicenceOnly = deepmerge(ecoLabelItemDataMock, {
  iconUrl: null,
  text: null,
  serviceLayerId: null,
});

export const ecoLabelItemDataMockIconOnly = deepmerge(ecoLabelItemDataMock, {
  license: null,
  text: null,
  serviceLayerId: null,
});

export const ecoLabelItemDataMockTextOnly = deepmerge(ecoLabelItemDataMock, {
  iconUrl: null,
  license: null,
  serviceLayerId: null,
});

export const ecoLabelItemFallbackHeadline = 'Unsere Öko-Produkte entdecken';
